/**
 * DetailsJePoliceSection - the «Details je Police» links on the Risikoprofil tab (Ch 7.1): the
 * branchenspezifischen Ist-Attribute live on the Police level (Slice 2), so the Kunde tab only
 * LINKS to each policy's «Risiko & Deckung». In Slice 1 it lists the customer's policies (derived
 * from the Basissparten policy links) and points to their detail view.
 *
 * Behind the `kunden.risikoprofil.details` Kachel visibility key.
 */

import type { BasisspartenItem } from '@brokly/shared';
import { EntityLink } from '../../../../components/ui/EntityLink';

export function DetailsJePoliceSection({
  items,
  onOpenPolicy,
}: {
  items: BasisspartenItem[];
  onOpenPolicy?: (policyId: string) => void;
}) {
  // Flatten the per-Sparte policy links into a de-duplicated list of (policyId, sparte label).
  const rows: { policyId: string; label: string }[] = [];
  const seen = new Set<string>();
  for (const item of items) {
    for (const pid of item.policy_ids) {
      if (seen.has(pid)) continue;
      seen.add(pid);
      rows.push({ policyId: pid, label: item.label });
    }
  }

  return (
    <section aria-labelledby="rp-details" className="rounded-lg border bg-card p-4" data-testid="rp-details">
      <h3 id="rp-details" className="text-sm font-semibold text-foreground">
        Details je Police
      </h3>
      <p className="mt-1 text-xs text-muted-foreground">
        Die branchenspezifischen Ist-Attribute und die Soll-Deckung werden pro Police gefuehrt.
      </p>
      {rows.length === 0 ? (
        <p className="mt-3 text-sm text-muted-foreground" data-testid="rp-details-empty">
          Keine Policen mit zugeordneter Sparte.
        </p>
      ) : (
        <ul className="mt-3 flex flex-col gap-2" data-testid="rp-details-list">
          {rows.map((row) => (
            <li key={row.policyId} className="flex items-center gap-2 text-sm">
              <span className="text-muted-foreground">{row.label}:</span>
              <EntityLink onActivate={onOpenPolicy ? () => onOpenPolicy(row.policyId) : undefined}>
                Risiko &amp; Deckung oeffnen
              </EntityLink>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
